import { createActionConst } from '../../../utils/action.utils';

const SUBSCRIPTION_NAMESPACE = 'SUBSCRIPTION';

export const STORE_SUBSCRIPTION = createActionConst(SUBSCRIPTION_NAMESPACE, 'STORE_SUBSCRIPTION');
export const CLEAR_SUBSCRIPTION = createActionConst(SUBSCRIPTION_NAMESPACE, 'CLEAR_SUBSCRIPTION');
